import { Badge, Button, Tag, Tooltip } from 'antd';
import { CalendarOutlined, ClockCircleOutlined, InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { NewGeogridBatchModal } from '../modal/NewGeogridBatchModal';
import { getLocalHourFromUtcHour } from './TimezoneUtils';
import { KW_SCOPE } from '../../../menuInfo/pageCompetitors/business/LocalSEO';

export const Terms = (props: { keywords: any}) => {
	
	return (
		<>													                
			{ props.keywords?.map((kw: any, index: any) => {
				return <Term keyword={kw} key={index}/>
			})
			}        			     
		</>
	)
}

export const Term = (props: { keyword: any }) => {
	
	return (
		<Tag icon={KW_SCOPE[props.keyword.scope].icon} style={{padding:'3px 8px', margin:'5px', fontSize:'14px'}} color='Teal'> {props.keyword.term}</Tag>
	)
}

export const Batch = (props: { kw: any, onFinish: any, showLabel?: boolean}) => {
	
	const [scheduleKeywordModal, setScheduleKeywordModal] = useState(null);	
	let batch = props.kw.batch;
	const { showLabel = true } = props; 

	return (
		<>{batch ?
			<Tooltip title={
			<>
			<b style={{color:'Cyan'}}>Programado</b><br/><br/>
				{batch.schedule_type === 'weekly'? 
					<div> <b>Semanal:</b> {batch.schedule_days_of_week.map((n: any) => DAYS[n])}</div> 
					: 
					<div> <b>Mensual: </b>{batch.schedule_days_of_month.map((d:string) => d + 'th').join(', ')}</div>
				}
				<div> <b>Grid:</b> {batch.distance} mts. {batch.grid * 2 +1}x{batch.grid * 2 +1} </div>
				<div><b> Horas:</b> {batch.schedule_hours.map((h: number) => getLocalHourFromUtcHour(h) + ':00h').join(', ')} <b style={{marginLeft:'10px'}}> {Intl.DateTimeFormat().resolvedOptions().timeZone}</b></div>			
			</>
			}>			
			
			<Button shape='round' size='small' type='link' onClick={() => {setScheduleKeywordModal(props.kw)}} style={{cursor:showLabel? 'pointer' : 'default'}}>
			<small>{batch.schedule_type === 'weekly'? 
				<span><Badge status="processing" />{showLabel && <>Programado Semanal</>}</span> 
				: 
				<span><Badge status="processing" />{showLabel && <>Programado Mensual</>}</span> 
				}
			</small>			
			</Button>
		</Tooltip>
		:
		<Tooltip title={<> Sin programar</>}>			
			<Button shape='round' size='small' type='link' onClick={() => {setScheduleKeywordModal(props.kw)}} style={{cursor:showLabel? 'pointer' : 'default'}}>
				<Badge status="default"/>
				<small> {showLabel && <>Sin Programar</>}</small>
			</Button> 
		</Tooltip>
			}
			{showLabel && scheduleKeywordModal && <NewGeogridBatchModal keyword={scheduleKeywordModal} onFinish={() => {props.onFinish(); setScheduleKeywordModal(null);}} onClose={() => {setScheduleKeywordModal(null);}}/>}										
		</>
	)
}

export const BatchView = (props: { kw: any}) => {
		
	let batch = props.kw.batch;
	
	return (
		<>{batch ?
			<Tooltip placement="bottom" title={
			<div>
				{batch.schedule_type === 'weekly'? 
					<div> <b>Semanal:</b> {batch.schedule_days_of_week.map((n: any) => DAYS[n])}</div> 
					: 
					<div> <b>Mensual: </b>{batch.schedule_days_of_month.map((d:string) => d + 'th').join(', ')}</div>
				}
				<div> <b>Grid:</b> {batch.distance} mts. {batch.grid * 2 +1}x{batch.grid * 2 +1} </div>
				<div><b> Horas:</b> {batch.schedule_hours.map((h:string) => h + ':00h').join(', ')}</div>			
			</div>
			}>			
			
			<>
			<small>{batch.schedule_type === 'weekly'? 
				<span><Badge status="processing"/> Programado Semanal</span> 
				: 
				<span><Badge status="processing"/> Programado Mensual</span> 
				}
			</small>			
			</>
		</Tooltip>
		:
		<>
			<small><Badge status="default"/> Sin Programar</small>
		</> 
			}			
		</>
	)
}

export const DAYS: any = {
	
	"0": " Domingo",  
	"1": " Lunes",  
	"2": " Martes",  
	"3": " Miércoles",  
	"4": " Jueves",  
	"5": " Viernes",  
	"6": " Sábado",   
  }
